import React from 'react';
import { Link } from 'react-router-dom';
import '../ds/tokens/fonts.css';
import '../ds/tokens/tokens.css';
import '../ds/styles/components.css';
import '../guia-home.css';
import Brujula from '../ds/components/Brujula';
import FondoMosaico from './FondoMosaico';

// Marco común de las páginas fuera de la conversación (perfil, privacidad): mismo fondo, cabecera y pie que la home.
const MarcoMarca = ({ pantalla, lado, children }) => (
  <div className="gh-root" data-theme="claro">
    <FondoMosaico pantalla={pantalla} />
    <header className="gh-header">
      <a href="/" className="gh-logo" aria-label="GUIA, ir al inicio"><Brujula sobreClaro /></a>
      {lado && <div className="gh-header__lado">{lado}</div>}
    </header>
    <main id="contenido" className="gh-escena gp-escena">{children}</main>
    <footer className="gh-pie">
      <span>Córdoba, Argentina</span>
      <Link to="/privacidad">Privacidad</Link>
    </footer>
  </div>
);

export default MarcoMarca;
